import React from 'react';
import clsx from 'clsx';

import styles from './Button.module.scss';

export default function Button({
	className,
	variant,
	text,
	icon,
	show,
	link,
	...rest
}) {
	if (show == undefined) {
		show = true;
	}

	let buttonContent = (
		<button
			className={clsx(styles.root, className, variant && styles[variant])}
			{...rest}
		>
			{icon}
			{text}
		</button>
	);

	if (link) {
		buttonContent = (
			<a href={link} target="_blank">
				{buttonContent}
			</a>
		);
	}

	return show ? buttonContent : null;
}

export const ButtonStyles = {
	PRIMARY: 'primary',
	SECONDARY: 'secondary',
	SPECIAL: 'special',
	GHOST: 'ghost'
};
